import { useEffect, useState } from 'react'
import { IntlProvider } from 'react-intl'

import Toggles from '@domain/toggles/Toggles'
import { setFormValidationMessages } from '@/utils'
import { i18nService } from '@/services'
import { LANGUAGE_CODES_LOCALE } from '@/constants'

interface IntlWrapperProps {
	children: React.ReactNode
	language: keyof typeof LANGUAGE_CODES_LOCALE
}

const IntlWrapper = (props: IntlWrapperProps) => {
	const { children, language } = props

	const [defaultMessages, setDefaultMessages] = useState<Record<string, string>>({})
	const [messages, setMessages] = useState<Record<string, string> | null>(null)
	const [locale, setLocale] = useState(LANGUAGE_CODES_LOCALE[language])

	useEffect(() => {
		; (async () => {
			Promise.all([
				i18nService.fetchFrontTranslations(language),
				i18nService.fetchEprojectTranslations(language),
				i18nService.fetchWidgetsTranslations(language)
			]).then(res => {
				setMessages(res.reduce((messages, { data: m }) => ({ ...messages, ...m }), defaultMessages))
				setDefaultMessages(res.reduce((messages, { data: m }) => ({ ...messages, ...m }), {}))
			})
			setLocale(LANGUAGE_CODES_LOCALE[language])
			setFormValidationMessages()
		})()
	}, [language])

	return messages ? (
		<IntlProvider messages={messages} locale={locale} onError={(error) => {
			if (/productSheetWidget\.[0-9]+\.mainTabs\.tab/.test(error.message)) {
				return
			}
			console.error(error)
		}}>
			{children}
		</IntlProvider>
	) : null
}

export { IntlWrapper }
